import moment, { Moment } from 'moment';

export const formatDate = (value: string | Moment | Date, time: boolean = false): string => {
    return moment(value).format(time ? process.env.NEXT_PUBLIC_DATE_TIME_FORMAT : process.env.NEXT_PUBLIC_DATE_FORMAT);
};
